/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ExportAPI
 * @hideconstructor
 *
 * @classdesc
 */
define([], () => {
	class CsvExportAPI {

		/**
		 * @function CsvExportAPII#export
		 * @description Export a csv file with supplied name & data.
		 * @param {String} fileName The name of the CSV file
		 * @param {object[][]} dataArrays An array of data arrays to aggregate and export
		 * @return {object} returns a Blob containing the exported CSV data
		 * @example
		 */
		export(/* fileName, dataArrays */) {}

	}

	return CsvExportAPI;
});
